import styled from 'styled-components';

import Button from '../../../components/Button';
import Icon from '../../../components/Icon';


const ModalContainer = styled.div`
  background: #FFF;  
`;

const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: var(--luft-primary);
  padding: 16px 24px;
`;

const ModalTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: #fff;
`;

const ModalContent = styled.div`
  padding: 24px;  
`;

const ContentText = styled.div`
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ModalFooter = styled.div`
  margin: 0 24px 24px 24px;
  display: flex;  
  justify-content: flex-end;
`;

const StyledButton = styled(Button)`
  &:first-child {
    background: var(--luft-secondary-darker);
    margin-right: 16px;
  }
  
  width: 100%;
  border-radius: 4px;
  text-transform: uppercase;
`;

const CloseButton = styled(Icon)`
  color: white;
  font-size: 24px;
  cursor: pointer;  
`;

export const S = {
  ModalContainer,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ContentText,
  ModalFooter,
  StyledButton,
  CloseButton,
};
